export function unixSecondsToDate(value) {
    if (value === null || value === undefined || value === "") return undefined;
    const seconds = Number(value);
    if (!Number.isFinite(seconds)) return undefined;
    return new Date(seconds * 1000);
}
